import { render, staticRenderFns } from "./TransactionLogs.vue?vue&type=template&id=8931152a"
import script from "./TransactionLogs.vue?vue&type=script&lang=js"
export * from "./TransactionLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports